export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/thinkbit/conference/hosting/~/angularfire2/database/index.js
// module id = ../../../../angularfire2/database/index.js
// module chunks = 22